import {Button} from 'primereact/button'
import {Dropdown} from 'primereact/dropdown'
import {InputMask} from 'primereact/inputmask'
import {InputText} from 'primereact/inputtext'
import {MultiSelect} from 'primereact/multiselect'
import {Password} from 'primereact/password'
import React, {useCallback, useMemo, useRef} from 'react'
import {useParams} from 'react-router-dom'
import {checkEmptyString} from '../../utils/CommonUtils'

import {useSignal} from '@preact/signals-react'
import {useSignals} from '@preact/signals-react/runtime'
import {Divider} from 'antd'
import {Avatar} from 'primereact/avatar'
import {Checkbox} from 'primereact/checkbox'
import {ConfirmPopup, confirmPopup} from 'primereact/confirmpopup'
import {Dialog} from 'primereact/dialog'
import {useLocation} from 'react-router-dom/cjs/react-router-dom.min'
import {SystemRole} from '../../Constants'
import avatar from '../../assets/images/avatar.jpg'
import {useAppConfig} from '../../context/app/AppContext'
import TranslateUtils from '../../i18n/TranslateUtils'
import {getSuperAdminRole} from '../authentication/AuthUtils'
import CodeConfig from '../client/CodeConfig'
import {updateImgList} from '../detail/DetailConstant'
import {component, formLayout, getComposedDataList} from '../form/Constant'
import GeneralPractitionerUtils from '../general-practioner/GeneralPractitionerUtils'
import GenericLogTable from '../generic-log/GenericLogTable'
import {severityNotification} from '../notification/NotificationConstant'
import {showNotification} from '../notification/NotificationService'
import {patientKeys} from '../patient/PatientConstants'
import {useRoleContext} from '../role/RoleProvider'
import {convertKeyToLabel} from '../table-utils/TableUtils'
import AddressDetailForm from './AddressDetailForm'
import {informationList} from './Constants'
import CustomForm from './CustomForm'

const fontSize = 'text-md sm:text-md md:text-4xl lg:text-4xl'
const CustomDetailForm = ({
    PATH = '',
    initialData = {}, // Use For Non-Self-Controlled (Render) & Initial Data
    dataList,
    treatAsRole,

    /* Boolean */
    profile = false,
    activeHcp = false,
    renderSubmitButton = true,
    renderRoles = false,

    /* Handle */
    onSubmit = () => {},
    onDelete = () => {},
}) => {
    useSignals()
    //#region Context
    const {userRole, timezoneId} = useAppConfig()
    const {myRolePermissions} = useRoleContext()
    //#endregion

    //#region Translate
    const {
        translateCommons,
        translateKeys,
        translateDatatable,
        translateOptions,
    } = TranslateUtils()

    //#endregion

    //#region Import
    const location = useLocation()
    const {id: idString} = useParams()
    const id = useMemo(() => {
        if (!idString) {
            return null
        }
        return parseInt(idString)
    }, [idString])
    //#endregion

    //#region Query
    // const queryClient = useQueryClient()
    //#endregion

    //#region State
    const visibleDialog = useSignal(false)
    const formData = useSignal({...initialData}) // Use for Self-Controlled Component (Render Group)
    //#endregion

    //#region Ref
    // const formRef = useRef(null)
    const genericRef = useRef(null)
    const myRefs = useRef([])
    //#endregion

    //#region Reload
    // const {mutate: handleReloadInfo} = useMutation(data => data, {
    //     onSuccess: data => {
    //         if (!!data?.id) {
    //             queryClient.setQueryData(
    //                 [QueryKey, user?.id, treatAsRole, id],
    //                 () => data,
    //             )
    //         }
    //     },
    // })

    // const handleReloadData = useCallback(
    //     data => {
    //         if (data && data?.id && data?.id === id) {
    //             handleReloadInfo(data)
    //         }
    //     },
    //     [id, handleReloadInfo],
    // )
    //#endregion

    //#region Event Listener
    // useEffect(() => {
    //     if (!!QueryKey && !!id) {
    //         detailEvent.on(
    //             'DETAIL-INFORMATION-RELOAD-' + QueryKey + id,
    //             handleReloadData,
    //         )

    //         refetchEvent.on('REFETCH-DATA-TABLE-' + QueryKey, refetch)

    //         return () => {
    //             removeDetailInformationReload(QueryKey + id)
    //             refetchEvent.removeListener('REFETCH-DATA-TABLE-' + QueryKey)
    //         }
    //     }
    // }, [handleReloadData, QueryKey, id, refetch])
    //#endregion

    //#region Memo
    const composedDataList = useMemo(() => {
        return getComposedDataList(dataList, formData.value)
    }, [formData.value, dataList])

    const isAllowToEdit = useMemo(() => {
        if (!!getSuperAdminRole() || userRole === SystemRole.ADMIN) {
            return true
        }

        if (!!myRolePermissions) {
            if (PATH === 'user') {
                if (location.pathname) {
                    if (location.pathname.includes('/patients')) {
                        return myRolePermissions?.permissions?.find(
                            item => item?.roleCategory === 'patientManagement',
                        )?.allowToEdit
                    }

                    if (location.pathname.includes('/hcp')) {
                        return myRolePermissions?.permissions?.find(
                            item => item?.roleCategory === 'hcpManagement',
                        )?.allowToEdit
                    }
                }
            }
        }
        return true
    }, [PATH, location.pathname, myRolePermissions, userRole])
    //#endregion

    //#region Handle Function
    const handleOnSetActive = useCallback(() => {
        if (onSubmit) {
            onSubmit({
                ...formData.value,
                active: true,
            })
        }
    }, [formData, onSubmit])

    const handleOnSubmit = () => {
        let toPostData = {
            ...formData.value,
        }

        if (
            !toPostData?.firstName ||
            !!checkEmptyString(toPostData?.firstName)
        ) {
            showNotification(
                severityNotification.error,
                'First Name is required !!',
            )
            return
        }

        if (onSubmit) {
            if (PATH === 'client') {
                if (
                    myRefs.current['codeConfig'] &&
                    myRefs.current['codeConfig']?.getValue()
                ) {
                    onSubmit({
                        ...toPostData,
                        ...myRefs.current['codeConfig']?.getValue(),
                    })
                } else {
                    onSubmit({
                        ...toPostData,
                    })
                }
            } else {
                onSubmit(toPostData)
            }
        }
    }

    // const handleShowForm = useCallback(data => {
    //     formRef.current.showForm(!!data ? {...data} : {})
    // }, [])

    const handleDeleteHospitalRole = useCallback(
        rowData => {
            let toDeleteData = {
                ...rowData,
            }

            if (
                formData.value &&
                formData.value?.userRoles &&
                formData.value?.userRoles?.length > 0
            ) {
                if (formData.value?.userRole?.length < 2) {
                } else {
                    if (onDelete) {
                        onDelete(toDeleteData)
                    }
                }
            }
        },
        [formData, onDelete],
    )

    const confirm = useCallback(
        (event, rowData) => {
            // if (initialData && initialData?.userRoles?.length > 0) {
            //     setVisible(true)

            //     if (initialData?.userRoles?.length === 1) {
            //         setShowWarning(true)
            //     }
            // }

            confirmPopup({
                target: event.currentTarget,
                message: (
                    <div className="w-full flex flex-column">
                        <div className="flex align-items-center font-bold w-full">
                            <p className="text-xl font-bold mb-0">
                                {translateKeys(
                                    'Are you sure you want to delete user role?',
                                )}
                            </p>
                        </div>
                        {initialData &&
                            initialData?.userRoles &&
                            initialData?.userRoles?.length === 1 && (
                                <div
                                    className="w-full"
                                    style={{
                                        color: 'red',
                                    }}>
                                    <i>
                                        <b>{translateKeys('Note')}</b>:{' '}
                                        {translateKeys(
                                            "This is hcp's only hospital role",
                                        )}
                                        {'. '}
                                        {translateKeys(
                                            "If you delete it, this hcp won't be able to access the system again",
                                        )}
                                        {'. '}
                                    </i>
                                </div>
                            )}
                    </div>
                ),
                header: translateKeys('Confirmation'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: translateCommons('Yes'),
                acceptClassName: 'p-button-danger',
                rejectLabel: translateCommons('No'),
                accept: () => handleDeleteHospitalRole(rowData),
            })
        },
        [
            initialData,
            handleDeleteHospitalRole,
            translateCommons,
            translateKeys,
        ],
    )

    const handleUpdateImg = value => {
        const toPostData = {
            ...formData.value,
            ...value,
        }

        if (onSubmit) {
            onSubmit(toPostData)
        }

        visibleDialog.value = false
    }
    //#endregion

    //#region Render
    const renderItem = useCallback(
        itemList => {
            return itemList.map((item, index) => (
                <div
                    key={item.key + '-' + index}
                    className={`${
                        item.component === component.address ||
                        item.component === component.generalPractitioner ||
                        item.component === component.codeConfiguration ||
                        item.key === patientKeys.currentLocation
                            ? 'col-12'
                            : 'col-12 md:col-6  xl:col-4'
                    } flex align-items-center p-0 mb-3`}>
                    {item.component === component.password ? (
                        <div
                            key={item.key}
                            className="text-900 col-12 line-height-3 p-float-label">
                            <Password
                                inputId="password"
                                className=" custom-detail h-3rem col-12 font-semibold"
                                value={formData.value[item.key] || ''}
                                onChange={e =>
                                    (formData.value = {
                                        ...formData.value,
                                        [item.key]: e.target.value,
                                    })
                                }
                            />

                            <div className="customLine"></div>
                            <label className="ml-2" htmlFor={item.key}>
                                {translateKeys(
                                    item.label
                                        ? item.label
                                        : convertKeyToLabel(item.key),
                                )}
                            </label>
                        </div>
                    ) : item.component === component.inputText ? (
                        <div
                            key={item.key}
                            className="text-900 col-12 line-height-3">
                            <span className={`${'p-float-label'} col-12 p-0`}>
                                <InputText
                                    className="custom-detail h-3rem col-12 font-semibold"
                                    value={formData.value[item.key] || ''}
                                    keyfilter={
                                        item.keyFilter
                                            ? /^[^<>*!/^|?,+= ]+$/
                                            : ''
                                    }
                                    onChange={e =>
                                        (formData.value = {
                                            ...formData.value,
                                            [item.key]: e.target.value,
                                        })
                                    }
                                />
                                <span className="bar"></span>
                                <label htmlFor={item.key} className="">
                                    {translateKeys(
                                        item.label
                                            ? item.label
                                            : convertKeyToLabel(item.key),
                                    )}
                                </label>
                            </span>
                        </div>
                    ) : item.component === component.inputMask ? (
                        <div
                            key={item.key}
                            className="text-900 col-12 line-height-3">
                            <span className={`${'p-float-label'} col-12 p-0`}>
                                <InputMask
                                    id={item.key}
                                    className={`col-12 custom-detail h-3rem font-semibold`}
                                    mask="99-99-9999"
                                    value={formData.value[item.key] || ''}
                                    placeholder={item.placeholder}
                                    slotChar="DD-MM-YYYY"
                                    onChange={e =>
                                        (formData.value = {
                                            ...formData.value,
                                            [item.key]: e.target.value,
                                        })
                                    }
                                />
                                <span className="bar"></span>
                                <label className="ml-2" htmlFor={item.key}>
                                    {translateKeys(
                                        item.label
                                            ? item.label
                                            : convertKeyToLabel(item.key),
                                    )}
                                </label>
                            </span>
                        </div>
                    ) : item.component === component.dropdown ? (
                        <div
                            key={item.key}
                            className="text-900 col-12 line-height-3">
                            <span className={`${'p-float-label'} col-12 p-0`}>
                                <Dropdown
                                    className={`${
                                        item.className ? item.className : ''
                                    } ${'custom-detail'} col-12 p-0 font-semibold`}
                                    inputId={item.key}
                                    options={translateOptions(item.options)}
                                    optionLabel="label"
                                    optionValue="value"
                                    defaultValue={
                                        item.initialValue
                                            ? item.initialValue
                                            : item.defaultValue
                                    }
                                    filter
                                    filterBy="label"
                                    emptyFilterMessage={translateCommons(
                                        'No available options',
                                    )}
                                    emptyMessage={translateCommons(
                                        'No results found',
                                    )}
                                    value={formData.value[item.key]}
                                    onChange={e =>
                                        (formData.value = {
                                            ...formData.value,
                                            [item.key]: e.value,
                                        })
                                    }
                                    placeholder={item.placeholder}
                                    style={{
                                        '--inputColor':
                                            'rgba(68, 184, 166, 0.1)',
                                    }}
                                />
                                <span className="bar"></span>
                                <label className="" htmlFor={item.key}>
                                    {translateKeys(
                                        item.label
                                            ? item.label
                                            : convertKeyToLabel(item.key),
                                    )}
                                </label>
                            </span>
                        </div>
                    ) : item.component === component.multiSelect ? (
                        <div
                            key={item.key}
                            className="text-900 col-12 m-0 p-0 line-height-3">
                            <span className={`${'p-float-label'} col-12 px-0`}>
                                <MultiSelect
                                    className={`col-12 p-inputtext p-0 ${'custom-detail'} font-semibold`}
                                    value={item.initialValue}
                                    defaultValue={
                                        item.initialValue
                                            ? item.initialValue
                                            : item.defaultValue
                                    }
                                    options={translateOptions(item.options)}
                                    onChange={e =>
                                        (formData.value = {
                                            ...formData.value,
                                            [item.key]: e.value,
                                        })
                                    }
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder={`${item.placeholder}`}
                                    emptyFilterMessage={translateCommons(
                                        'No results found',
                                    )}
                                    resetFilterOnHide
                                    display="chip"
                                    filter
                                    filterBy="label"
                                    style={{
                                        '--inputColor':
                                            'rgba(68, 184, 166, 0.1)',
                                    }}
                                />
                                <label className="ml-2" htmlFor={item.key}>
                                    {translateKeys(
                                        item.label
                                            ? item.label
                                            : convertKeyToLabel(item.key),
                                    )}
                                </label>
                            </span>
                        </div>
                    ) : item.component === component.address ? (
                        <AddressDetailForm
                            shouldTextBold={true}
                            data={formData.value}
                            onChange={e =>
                                (formData.value = {...formData.value, ...e})
                            }
                        />
                    ) : item.component === component.generalPractitioner ? (
                        <GeneralPractitionerUtils
                            shouldTextBold={true}
                            className={item.className ? item.className : ''}
                            childrenClassName={
                                item.childrenClassName
                                    ? item.childrenClassName
                                    : ''
                            }
                            onChange={value =>
                                (formData.value = {
                                    ...formData.value,
                                    generalPractitioner: value,
                                })
                            }
                            defaultValue={
                                item.initialValue ? item.initialValue : {}
                            }
                            customDetail={true}
                        />
                    ) : item.component === component.codeConfiguration ? (
                        <div className="col-12 m-0 p-0">
                            <CodeConfig
                                id="codeConfig"
                                ref={el => (myRefs.current['codeConfig'] = el)}
                                defaultValue={formData.value?.userCodeRules}
                            />
                        </div>
                    ) : item.component === component.checkbox ? (
                        <React.Fragment>
                            <Checkbox
                                checked={formData.value[item.key]}
                                onChange={e =>
                                    (formData.value = {
                                        ...formData.value,
                                        [item.key]: e.checked,
                                    })
                                }
                            />
                            <div className="flex align-items-center mb-0">
                                <label htmlFor={item.key} className="ml-2 mb-0">
                                    {translateKeys(convertKeyToLabel(item.key))}
                                </label>
                            </div>
                        </React.Fragment>
                    ) : null}
                </div>
            ))
        },
        [formData, translateCommons, translateKeys, translateOptions],
    )

    const renderGroup = useCallback(() => {
        if (composedDataList && Array.isArray(composedDataList)) {
            return composedDataList.map(item => (
                <div key={item.key} className="col-12 p-0">
                    <li className="flex mb-1 border-round-top pl-2 align-items-center py-3 flex-wrap lightgray">
                        <div className={`pl-2 text-2xl font-bold w-full`}>
                            {!!item?.icon && (
                                <span className="mr-3">
                                    <i
                                        className={`font-bold text-xl ${item.icon}`}></i>
                                </span>
                            )}
                            {translateKeys(convertKeyToLabel(item.key))}
                        </div>
                    </li>

                    <li
                        className={`col-12 grid align-items-center pt-3 px-0 flex-wrap`}>
                        {renderItem(item.children)}
                    </li>
                </div>
            ))
        }
    }, [composedDataList, renderItem, translateKeys])

    const summaryOfNumbers = useMemo(() => {
        if (!initialData || !initialData?.id) {
            return []
        }

        return informationList.map(item => ({
            ...item,
            value: initialData[item.key],
        }))
    }, [initialData])

    // const actionBodyTemplate = useCallback(
    //     rowData => {
    //         let hcpPermission = null
    //         if (!!myRolePermissions) {
    //             hcpPermission = myRolePermissions?.permissions?.find(
    //                 item => item?.roleCategory === 'hcpManagement',
    //             )
    //         }
    //         return (
    //             ((!!hcpPermission && !!hcpPermission?.allowToAssignHcpRole) ||
    //                 userRole === SystemRole.ADMIN ||
    //                 !!getSuperAdminRole()) && (
    //                 <div className="flex gap-2 align-items-center">
    //                     <Button
    //                         className="p-button-rounded "
    //                         icon="pi pi-pencil"
    //                         aria-label={translateKeys('Edit')}
    //                         tooltip={translateKeys('Edit')}
    //                         onClick={() => handleShowForm(rowData)}
    //                         tooltipOptions={{
    //                             position: 'top',
    //                         }}
    //                     />

    //                     {((!!hcpPermission &&
    //                         !!hcpPermission?.allowToDeleteHcpRole) ||
    //                         userRole === SystemRole.ADMIN ||
    //                         !!getSuperAdminRole()) && (
    //                         <Button
    //                             icon="pi pi-trash"
    //                             severity="danger"
    //                             className="p-button-rounded p-button-danger p-button-outlined "
    //                             onClick={e => confirm(e, rowData)}
    //                             tooltip={translateKeys('Delete')}
    //                             tooltipOptions={{position: 'top'}}
    //                         />
    //                     )}
    //                 </div>
    //             )
    //         )
    //     },
    //     [confirm, handleShowForm, myRolePermissions, translateKeys, userRole],
    // )
    // const hcpDetailTableShownColumn = useMemo(() => {
    //     const defaultColumns = [
    //         {key: 'hospitalName'},
    //         {key: 'hospitalNumber'},
    //         {key: 'roleName'},
    //         {key: 'roleDescription'},
    //         {key: 'qualified'},
    //         {key: 'active'},
    //         {key: 'createdAt'},
    //         {
    //             key: 'action',
    //             renderBody: data => actionBodyTemplate(data),
    //         },
    //     ]

    //     if (!!getSuperAdminRole() || userRole === SystemRole.ADMIN) {
    //         return defaultColumns
    //     }

    //     if (!!myRolePermissions) {
    //         let hcpPermission = myRolePermissions?.permissions?.find(
    //             item => item?.roleCategory === 'hcpManagement',
    //         )
    //         if (!!hcpPermission?.allowToAssignHcpRole) {
    //             return defaultColumns
    //         }
    //     }

    //     return [
    //         {key: 'hospitalName'},
    //         {key: 'hospitalNumber'},
    //         {key: 'roleName'},
    //         {key: 'roleDescription'},
    //         {key: 'qualified'},
    //         {key: 'active'},
    //         {key: 'createdAt'},
    //     ]
    // }, [userRole, myRolePermissions, actionBodyTemplate])
    // const renderRolesTable = useCallback(() => {
    //     return (
    //         data && (
    //             <div className="col-12 m-0 p-0">
    //                 <DataTable
    //                     className="col-12 p-0"
    //                     header={
    //                         <div className="flex justify-content-between align-items-center ">
    //                             <h3 className="mb-1 font-bold">
    //                                 {data?.firstName
    //                                     ? `${
    //                                           data?.firstName
    //                                       }'s ${translateDatatable('Roles')}`
    //                                     : ''}
    //                                 <hr
    //                                     className="highlighter"
    //                                     style={{width: '70%'}}
    //                                 />
    //                             </h3>

    //                             <div className="grid justify-content-between align-items-center gap-2">
    //                                 <Button
    //                                     className="px-3 gap-1"
    //                                     label={translateDatatable(
    //                                         'Assign new role',
    //                                     )}
    //                                     icon="pi pi-plus"
    //                                     onClick={handleShowForm}
    //                                 />
    //                                 <AuditLogButton
    //                                     label={translateDatatable(
    //                                         'Show Audit Log',
    //                                     )}
    //                                     onClick={() => {
    //                                         if (
    //                                             !!id &&
    //                                             !!data &&
    //                                             !!data['userRoleIds']
    //                                         ) {
    //                                             genericRef.current.showForm({
    //                                                 refIds: data['userRoleIds'],
    //                                                 type: 'hcpRoleLog',
    //                                             })
    //                                         } else {
    //                                             showNotification(
    //                                                 severityNotification.warn,
    //                                                 'No data found !!',
    //                                             )
    //                                         }
    //                                     }}
    //                                 />
    //                             </div>
    //                         </div>
    //                     }
    //                     value={data['userRoles'] ? data['userRoles'] : []}>
    //                     {hcpDetailTableShownColumn.map((item, idx) => (
    //                         <Column
    //                             key={item.key - idx}
    //                             field={item.key}
    //                             header={translateKeys(
    //                                 convertKeyToLabel(item.key),
    //                             )}
    //                             body={rowData => {
    //                                 if (
    //                                     item.key === 'qualified' ||
    //                                     item.key === 'active'
    //                                 ) {
    //                                     return !!rowData[item.key] ? (
    //                                         <Tag
    //                                             className="px-3"
    //                                             severity="success"
    //                                             value={translateCommons('Yes')}
    //                                         />
    //                                     ) : (
    //                                         <Tag
    //                                             severity="danger"
    //                                             value={translateCommons('No')}
    //                                             className="px-3"
    //                                         />
    //                                     )
    //                                 } else if (item.key === 'action') {
    //                                     return item.renderBody(rowData)
    //                                 } else {
    //                                     return (
    //                                         <div className="overflow-dot overflow-text-5">
    //                                             {rowData[item.key]
    //                                                 ? capitalize(
    //                                                       rowData[item.key],
    //                                                   )
    //                                                 : '-'}
    //                                         </div>
    //                                     )
    //                                 }
    //                             }}
    //                         />
    //                     ))}
    //                 </DataTable>
    //             </div>
    //         )
    //     )
    // }, [
    //     id,
    //     data,
    //     handleShowForm,
    //     hcpDetailTableShownColumn,
    //     translateCommons,
    //     translateDatatable,
    //     translateKeys,
    // ])

    //#endregion

    return (
        <div className="col-12 p-0">
            {/* Render Patient & Client Detail Stats */}
            {/* Use "Initial Data" for Non-Self-Controlled Component (For Refetch) */}
            {!profile && PATH !== 'user' && (
                <div className=" col-12 surface-section m-0">
                    <div className="flex align-items-start flex-column lg:flex-row lg:justify-content-between col-12 p-0">
                        <div className="flex align-items-start flex-column md:flex-row p-0">
                            <Avatar
                                className="mr-5 mb-3 lg:mb-0 border-circle"
                                style={{width: '120px', height: '120px'}}
                                image={
                                    initialData && initialData?.avatar
                                        ? initialData.avatar
                                        : avatar
                                }
                                size="xlarge"
                                shape="circle"
                            />
                            <div className={``}>
                                <span
                                    className={`font-bold ${fontSize} m-0 flex align-items-center`}
                                    style={{
                                        color: 'rgba(20,184,166)',
                                    }}>
                                    {`${initialData?.firstName} ${initialData?.lastName}`}
                                    <i className="pi pi-star ml-4 text-yellow-500"></i>
                                </span>
                                {initialData?.systemRole ===
                                    SystemRole.USER && (
                                    <div className="m-1">
                                        <h4
                                            className="font-bold"
                                            style={{color: 'gray'}}>
                                            {translateKeys('Hospital Name')} :
                                            {initialData?.hospitalName}
                                        </h4>
                                        <div className="flex  align-items-center ">
                                            <div className="text-xl">
                                                <span>
                                                    {translateKeys('Battery')}
                                                </span>
                                                <div className="text-600 justify-content-center">
                                                    {initialData && (
                                                        <p className="text-color-secondary text-md text-center font-bold">
                                                            {initialData.batteryLife
                                                                ? initialData.batteryLife +
                                                                  '%'
                                                                : '-'}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                            <Divider layout="vertical" />
                                            <div className="text-xl">
                                                <span>
                                                    {translateKeys(
                                                        'Number of Devices',
                                                    )}
                                                </span>
                                                <div className="text-600">
                                                    {initialData && (
                                                        <p className="text-color-secondary text-md text-center font-bold">
                                                            {
                                                                initialData.numberOfDevices
                                                            }
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {initialData?.systemRole ===
                                    SystemRole.ADMIN && (
                                    <div className="col-12 p-0">
                                        <div className="flex align-items-center">
                                            <span className="font-medium text-xl">
                                                {translateKeys('Owned By')}:{' '}
                                                {` `}
                                                {!!initialData?.title
                                                    ? convertKeyToLabel(
                                                          initialData?.title,
                                                      )
                                                    : ''}
                                                {`  ${
                                                    initialData?.firstName
                                                        ? initialData.firstName
                                                        : '-'
                                                } ${
                                                    initialData?.lastName
                                                        ? initialData.lastName
                                                        : '-'
                                                }`}
                                            </span>
                                        </div>
                                        <div className="flex align-items-center flex-wrap text-sm">
                                            {summaryOfNumbers.map(item => (
                                                <div
                                                    key={item.key}
                                                    className="pr-5 mt-3 col-6">
                                                    <span className="font-medium text-lg text-500">
                                                        {translateKeys(
                                                            item.label,
                                                        )}
                                                    </span>
                                                    <div className="flex align-items-center text-700 text-xl mr-2 mt-2">
                                                        {item.icon}
                                                        <span>
                                                            {item.value
                                                                ? item.value
                                                                : '0'}
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="mt-3 lg:mt-0">
                            <Button
                                icon="pi pi-fw pi-images"
                                className="p-button-rounded mr-2"
                                onClick={() => (visibleDialog.value = true)}
                            />
                        </div>
                        <Dialog
                            header={
                                <h5 className="mb-0 font-bold">
                                    <strong>
                                        {translateKeys('Change Avatar')}
                                    </strong>
                                </h5>
                            }
                            style={{width: '40vw'}}
                            breakpoints={{
                                '960px': '75vw',
                                '641px': '100vw',
                            }}
                            visible={visibleDialog.value}
                            onHide={() => (visibleDialog.value = false)}>
                            <CustomForm
                                onSubmit={handleUpdateImg}
                                layout={formLayout.inline}
                                dataList={updateImgList}
                            />
                        </Dialog>
                    </div>
                </div>
            )}
            {/* Render Patient Information's Log & Pathways */}
            {PATH === 'user' && (
                <React.Fragment>
                    <ul className="m-0 p-0">
                        <li className="flex mb-1 border-round justify-content-center align-items-center py-3 px-2 flex-wrap lightgray ">
                            <div
                                className={`pl-2 text-2xl font-bold w-full lg:text-center`}>
                                <span className="mr-3">
                                    <i className="pi pi-user font-bold text-xl"></i>
                                </span>
                                {translateCommons(
                                    "Patient's Information Audit Log",
                                )}
                            </div>
                        </li>

                        <li className="flex align-items-center py-3 flex-wrap col-12">
                            <div
                                className={`col-12 m-0  p-0 flex gap-2   flex-column md:flex-row align-items-center justify-content-center md:justify-content-between`}>
                                <h5 className="m-0 text-base md:text-lg   text-700">
                                    {translateCommons(
                                        "The audit log shows various changes in patient's account since the account was created. It saves a record of these changes indefinitely, and you can view the entire change history.",
                                    )}
                                </h5>
                                <Button
                                    className="p-button-text audit-button gap-1  px-3 "
                                    icon="pi pi-download"
                                    label={translateCommons('Show Audit Log')}
                                    onClick={() =>
                                        !!id &&
                                        genericRef.current.showForm({
                                            refId: id,
                                            type: 'userLog',
                                        })
                                    }
                                />
                            </div>
                        </li>
                    </ul>
                    {/* <ul className="p-0 m-0">
                        <li className="flex mb-1 border-round  align-items-center py-3 px-2 flex-wrap lightgray ">
                            <div
                                className={`pl-2 text-2xl font-bold w-full ${
                                    width < 992 ? 'text-center' : ''
                                }`}>
                                <span className="mr-3">
                                    <i className="pi pi-directions font-bold text-xl"></i>
                                </span>
                                {translateCommons('Pathway')}
                            </div>
                        </li>

                        <li className="flex align-items-center py-3 flex-wrap col-12">
                            <div
                                className={`col-12 m-0 mb-1 p-0 flex align-items-center justify-content-center gap-2`}>
                                {initialData &&
                                    initialData?.pathways &&
                                    Object.keys(initialData.pathways).map(
                                        key => (
                                            <div
                                                key={key}
                                                className="pointer w-3rem">
                                                <Tooltip
                                                    target={`.tooltip-pathway-patient-${key}`}
                                                    position="top"
                                                    content={
                                                        initialData.pathways[
                                                            key
                                                        ]?.name
                                                    }
                                                />
                                                <div
                                                    className={`flex justify-content-center align-items-center text-700 tooltip-pathway-patient-${key} bg-gray-50 hover:bg-gray-100 border-round-lg p-2`}>
                                                    <Image
                                                        width="26"
                                                        height="26"
                                                        style={{
                                                            objectFit: 'cover',
                                                        }}
                                                        src={`${initialData.pathways[key]?.icon}`}
                                                    />
                                                </div>
                                            </div>
                                        ),
                                    )}
                            </div>
                        </li>
                    </ul> */}
                </React.Fragment>
            )}
            {/* Render When HCP is Inactive (Remove All Role) */}
            {/* TODO: Style */}
            {!initialData?.active &&
                initialData.systemRole === SystemRole.USER_WITH_ROLE && (
                    <div className="col-12 text-center mb-4 text-xl">
                        <span style={{color: 'red'}}>
                            {translateCommons('Click here to active user')}.
                        </span>
                        <span
                            className="pointer text-primary"
                            onClick={handleOnSetActive}>
                            {translateCommons('Click here to active user')}
                        </span>
                    </div>
                )}
            {/* Render Detail */}
            {renderGroup()}
            {!!renderSubmitButton && (
                <div className="col-12">
                    <Button
                        className={`col-12 p-button-lg font-bold`}
                        onClick={handleOnSubmit}
                        icon={'pi pi-send'}
                        label={translateCommons('APPLY EDIT')}
                    />
                </div>
            )}
            <ConfirmPopup />
            <GenericLogTable ref={genericRef} />
        </div>
    )
}

export default CustomDetailForm
